module.exports = __webpack_public_path__ + "img/channel.0b95b069.svg";